import { makeUseFetchOne } from '@elentari/core'
import { paisesRepository } from './paisesRepository'
import { PaisDetail } from '../types'

export const usePais = makeUseFetchOne<PaisDetail, string>({
  fetch: paisesRepository.fetchOne
})
